import TableCheckboxToggler from "../lib/table-checkbox-toggler";

$.widget.bridge('tableCheckboxToggler', TableCheckboxToggler);
